import React from 'react'
import { createPortal } from 'react-dom'
import { Modal as UIModal } from '@crossfit/ui'

type Props = React.ComponentProps<typeof UIModal>

function Modal(props: Props) {
  const portal = document.getElementById('portal')

  if (!portal) {
    return null
  }

  return createPortal(<UIModal {...props} />, portal)
}

export default Modal
